export const borderRadius = {
  kilo: '1px',
  mega: '4px',
  giga: '7px',
  tera: '9px',
  peta: '12px',
  exa: '50px',
  circle: '50%',
};
